import React from "react";
import {
  FaArrowLeft,
  FaBan,
  FaCheckCircle,
  FaClipboardCheck,
  FaUndo,
  FaUserCheck,
} from "react-icons/fa";
import { COMMISSION_BULK_ACTION_META } from "./commissionBulkActionCatalog";

const BULK_ACTION_UI = {
  mark_completed: {
    tone: "success",
    icon: <FaClipboardCheck size={14} />,
  },
  discontinue: {
    tone: "danger",
    icon: <FaBan size={13} />,
  },
  reactivate: {
    tone: undefined,
    icon: <FaUndo size={13} />,
  },
  revert_completed: {
    tone: undefined,
    icon: <FaUndo size={13} />,
  },
  submit_final_review: {
    tone: undefined,
    icon: <FaUserCheck size={13} />,
  },
  approve_final_review: {
    tone: "success",
    icon: <FaCheckCircle size={13} />,
  },
  return_final_review: {
    tone: undefined,
    icon: <FaUndo size={13} />,
  },
  remove_from_commissionable: {
    tone: "danger",
    icon: <FaArrowLeft size={13} />,
  },
};

/**
 * Row-actions menu items for the commissions bulk toolbar.
 *
 * @param {Array} actions from getVisibleBulkCommissionActions
 * @param {{ loading?: boolean, onRunAction?: (action: object) => void }} handlers
 */
export function buildBulkActionMenuItems(
  actions,
  { loading = false, onRunAction, selectedCount = 0 } = {},
) {
  return (actions || []).map((action) => {
    const meta = COMMISSION_BULK_ACTION_META[action.id] || {};
    const ui = BULK_ACTION_UI[action.id] || {};
    const eligible = action.eligibleCount ?? 0;
    const baseLabel = meta.label || action.label || action.id;

    let title = baseLabel;
    if (selectedCount > 0 && eligible < selectedCount) {
      title = eligible > 0
        ? `${baseLabel} — ${eligible} of ${selectedCount} selected qualify`
        : `${baseLabel} — none of ${selectedCount} selected qualify`;
    } else if (selectedCount > 0 && eligible === selectedCount) {
      title = `${baseLabel} — applies to all ${selectedCount} selected`;
    }

    return {
      key: action.id,
      show: true,
      type: "button",
      label: baseLabel,
      countBadge: selectedCount > 0 ? selectedCount : null,
      title,
      tone: ui.tone,
      icon: ui.icon,
      disabled: loading || eligible === 0,
      onClick: () => onRunAction?.(action),
    };
  });
}
